import type {
    TimelineItemProps as AntTimelineItemProps,
    TimelineProps as AntTimelineProps,
} from "antd";
import { Timeline as AntTimeline } from "antd";
import React from "react";

interface TimelineItem {
  key: string;
  label: string;
  color?: AntTimelineItemProps["color"];
  dot?: React.ReactNode;
  icon?: React.ReactNode;
  inverse?: boolean;
}

export interface TimelineProps extends AntTimelineProps {
  items: TimelineItem[];
}

const Timeline: React.FC<TimelineProps> = ({ items, ...props }) => {
  return (
    <AntTimeline {...props}>
      {items.map((item) => (
        <AntTimeline.Item
          key={item.key}
          color={item.color}
          dot={item.dot}
          style={{
            backgroundColor: item.inverse ? "#000" : undefined,
            color: item.inverse ? "#fff" : undefined,
          }}
        >
          {item.icon && <span style={{ marginRight: 8 }}>{item.icon}</span>}
          {item.label}
        </AntTimeline.Item>
      ))}
    </AntTimeline>
  );
};

export default Timeline;
